import React, { useState, useContext, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { FiEdit2, FiEye, FiPlus } from "react-icons/fi";
import { UserContext } from "../context/userContext";
import Loader from "../component/Loader";
import PageHead from "../component/PageHead";
import DeletePost from "./DeletePost";
import { FALLBACK_THUMB, authHeaders, fallbackTo, uploadUrl } from "../constants";

const Dashboard = () => {
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const { currentUser } = useContext(UserContext);
  const token = currentUser?.token;
  const { id } = useParams();

  useEffect(() => {
    if (!token) navigate("/login");
  }, [token, navigate]);

  useEffect(() => {
    const fetchPosts = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/posts/users/${id}`,
          authHeaders(token)
        );
        setPosts(response.data || []);
      } catch (error) {
        console.log(error);
      }
      setIsLoading(false);
    };
    fetchPosts();
  }, [id, token]);

  return (
    <div className="container">
      <PageHead num="D" label="Dashboard" line1="Your posts," line2="all in one place.">
        <Link to="/create" className="btn btn--primary">
          <FiPlus /> New post
        </Link>
      </PageHead>

      {isLoading ? (
        <Loader label="Loading your posts…" />
      ) : posts.length ? (
        <div className="list">
          {posts.map((post) => (
            <div key={post._id} className="list__row">
              <div className="list__thumb">
                <img src={uploadUrl(post.thumbnail)} alt="" onError={fallbackTo(FALLBACK_THUMB)} />
              </div>
              <div className="list__title">
                <h3>{post.title}</h3>
                <span className="eyebrow">{post.category}</span>
              </div>
              <div className="list__actions">
                <Link to={`/posts/${post._id}`} className="btn btn--sm btn--ghost">
                  <FiEye /> View
                </Link>
                <Link to={`/posts/${post._id}/edit`} className="btn btn--sm">
                  <FiEdit2 /> Edit
                </Link>
                <DeletePost
                  postId={post._id}
                  onDeleted={(pid) => setPosts((p) => p.filter((x) => x._id !== pid))}
                />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="empty">
          <h3>You haven't published anything yet</h3>
          <p>Your first post is one good idea away.</p>
          <Link to="/create" className="btn btn--primary">
            Write a post
          </Link>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
